module.exports = __webpack_public_path__ + "static/media/logo_euipn.12a0e580.svg";